import { Tabs } from 'antd';
import styled from 'styled-components';

export default styled(Tabs)`
	// Add your styles here
`;
